export default angular.module('syFile', [])
    /**
     * @ngdoc controller
     * @name  InputFileController
     * @description
     * Scope to control the the reading of a file
     */
    // @ngInject
    .controller('FileController', function () {
        var controller = this;
        this.currentFilename = '';
        // Returns true when a file has been selected
        this.isFileSelected = function () {
            return controller.currentFilename.length > 0;
        };
    })
    /**
     * @ngdoc directive
     * @name InputFileController.controller:inputfile
     * @description
     * Updates element witht he currentfilename on the controller.
     */
    // @ngInject
    .directive('syFileInput', function () {
        return {
            scope: true,
            restrict: 'AE',
            controller: 'FileController',
            controllerAs: 'fileController'
        };
    })
    /**
     * @ngdoc directive
     * @name InputFileController.controller:fileread
     * @description
     * Updates controllers currentFilename when changes on the element.
     */
    // @ngInject
    .directive('syFileRead', function ($timeout) {
        return {
            restrict: 'A',
            require: '^syFileInput',
            link: function ($scope, $element, attrs, controller) {
                $element.on('change', function (changeEvent) {
                    $timeout(function () {
                        controller.currentFilename = changeEvent.target.files[0].name;
                    });
                });
            }
        };
    });
